import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Las pesas me harán ver demasiado musculosa?',
  answer: 'Absolutamente no. A los 50+, las mujeres tenemos niveles muy bajos de testosterona. Construir músculo es una tarea difícil que requiere años de entrenamiento pesado. Lo que verás en el espejo es un cuerpo más firme, "apretado" y con mejor postura.'
}, {
  question: '¿Puedo seguir siendo vegetariana?',
  answer: 'Es posible, pero requiere más planificación. Deberá apoyarse en suplementos de proteína de chícharo o arroz y combinar legumbres con granos para alcanzar los 30g por comida.'
}, {
  question: '¿Necesito ir al gimnasio?',
  answer: 'No. El protocolo está diseñado para hacerse en casa con bandas de resistencia, mancuernas pequeñas o incluso una mochila con libros. No necesitas equipos costosos ni membresías.'
}, {
  question: '¿Cuánto tiempo hasta ver resultados?',
  answer: 'La mayoría de las mujeres reportan más energía y mejor sueño en 2-4 semanas. Los cambios visibles en composición corporal (más firmeza, menos hinchazón) aparecen entre 8-12 semanas con constancia.'
}, {
  question: '¿Es seguro si tengo problemas de rodillas?',
  answer: 'Siempre consulta con tu médico antes de comenzar. Los ejercicios en el libro son adaptables y de bajo impacto. Muchas mujeres con problemas articulares encuentran que el fortalecimiento muscular reduce el dolor.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-sage/10 py-16 md:py-24 px-4" data-id="element-35">
      <div className="max-w-4xl mx-auto" data-id="element-36">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-4xl md:text-5xl font-bold text-terracotta text-center mb-12" data-id="element-37">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-38">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream rounded-lg overflow-hidden shadow-md" data-id="element-39">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-6 flex items-center justify-between text-left hover:bg-sage/5 transition-colors" data-id="element-40">
                <span className="font-semibold text-lg text-brown pr-4" data-id="element-41">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-terracotta flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-42" />
              </button>
              <AnimatePresence data-id="element-43">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-44">
                    <div className="px-6 pb-6 text-brown leading-relaxed" data-id="element-45">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}